<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="500px"
    @close="close"
    >
    <el-row class="num-reason-content">
      <el-col class="num-item">
        商品总数：{{self_result.totalNum || 0}}款，成功{{self_result.successNum || 0}}款，失败{{self_result.failureNum || 0}}款,
        部分成功{{self_result.partialSuccessNum || 0}}款
      </el-col>
      <el-col class="reason-item" v-if="self_result.errorMsg">
        失败原因：
         <el-link @click="jumpLogDetail">{{self_result.errorMsg}}</el-link>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer" v-if="self_result.operationLogId">
      <el-button type="primary" @click="handleLog">查看日志</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
  props: {
    type: {
      type: String,
      default: 'joinSmallShop'
    }
  },
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '',
      self_result: {
         totalNum: 0,
         successNum: 0,
         failureNum: 0,
         errorMsg: '',
         operationLogId: '',
         partialSuccessNum: 0
      },
      jumpFn: null
    }
  },
  computed: {
    ...mapGetters(['routerPrefix']),
    title() {
      const titleMap = {
        joinSmallShop: '加入分销小店完成',
        batchJoinGoods: '批量加入分销商品完成',
        singleJoinGoods: '加入分销商品完成',  // 商品新增日志
        batchDistributionPrice: '批量改等级分销价完成',
        batchSalePrice: '批量改销售价同步系统资料',
        batchState: '批量设可见状态完成'
      }
      return this.dialogTitle || titleMap[this.type]
    }
  },
  methods: {
    ...mapMutations(['setActiveName']),
    method_open(data = {}, config = {}){
      this.dialogVisible = true;
      this.dialogTitle = config?.title
      this.self_result = {...data};
    },
    handleLog() {
      this.dialogVisible = false;
      let activeName = '';
      if(this.type == 'singleJoinGoods' || this.type == 'batchJoinGoods') {
        activeName = 'newProductLog'
      } else {
        activeName = 'shopOperationLog'
      }
      this.setActiveName(activeName);
      // 由于直接跳转可能导致el-dialog的蒙层dom未销毁
      // 所以用方法包裹跳转 在蒙层关闭后进行跳转 确保蒙层dom销毁
      this.jumpFn = () => {
        this.$router.push({
          name: `${this.routerPrefix}prod_log`,
        })
      }
    },
    jumpLogDetail() {
       let activeName = '';
      this.dialogVisible = false;
      if(this.type == 'singleJoinGoods' || this.type == 'batchJoinGoods') {
        activeName = 'newProductLog'
      } else {
        activeName = 'shopOperationLog'
      }
      this.setActiveName(activeName);
      // 由于直接跳转可能导致el-dialog的蒙层dom未销毁
      // 所以用方法包裹跳转 在蒙层关闭后进行跳转 确保蒙层dom销毁
      this.jumpFn = () => {
        this.$router.push({
          name: `${this.routerPrefix}prod_log`,
          query:{
            id: this.self_result.operationLogId
          }
        })
      }
    },
    close() {
      // 由于直接跳转可能导致el-dialog的蒙层dom未销毁
      // 所以用方法包裹跳转 在蒙层关闭后进行跳转 确保蒙层dom销毁
       if (this.jumpFn) {
          this.jumpFn()
          this.jumpFn = null
       }
       this.dialogVisible = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.num-item{
  margin-bottom: 10px;
}

</style>
